import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';
import { EXPORT_TAB_RESULT_STATUSES } from '../ExportTabConstants';
import './ExportTabTooltipFooter.scss';

function ExportTabTooltipFooter(props) {
  const { exportResult, cancel, retry, retryDisabled, downloadByURL } = props;
  const { status } = exportResult;

  return (
    <div className="exportTab__tooltip_footer">
      {status === EXPORT_TAB_RESULT_STATUSES.FINISHED && (
        <Button
          type="button"
          onClick={downloadByURL}
          buttonConfig={{
            label: 'Download',
            type: 'link',
            size: 'xs',
            e2eName: 'export-tab-download',
          }}
          iconConfig={{
            name: 'chevron-right',
          }}
        />
      )}

      <Button
        type="button"
        onClick={() => cancel()}
        buttonConfig={{
          label: 'Cancel',
          type: 'link',
          size: 'xs',
          e2eName: 'export-tab-cancel',
        }}
        iconConfig={{
          name: 'chevron-right',
        }}
      />

      {status === EXPORT_TAB_RESULT_STATUSES.CONNECTION_ERROR && (
        <Button
          type="button"
          onClick={retry}
          disabled={retryDisabled}
          buttonConfig={{
            label: 'Retry',
            type: 'link',
            size: 'xs',
            e2eName: 'export-tab-retry',
          }}
          iconConfig={{
            name: 'chevron-right',
          }}
        />
      )}
    </div>
  );
}

ExportTabTooltipFooter.propTypes = {
  exportResult: PropTypes.object,
  retryDisabled: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  retry: PropTypes.func.isRequired,
  downloadByURL: PropTypes.func.isRequired,
};

export default ExportTabTooltipFooter;
